import React, { useEffect, useState } from 'react';
import { Megaphone, Send, Trash2 } from 'lucide-react';
import { api } from './api';

export default function CommsTab({ tid }) {
  const [list, setList] = useState([]);
  const [msg, setMsg] = useState('');
  const [scope, setScope] = useState('all');
  const [busy, setBusy] = useState(false);

  const load = () => api.get(`/tournaments/${tid}/broadcasts`).then((r) => setList(r.data)).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [tid]);

  const send = async () => {
    if (!msg.trim()) return;
    setBusy(true);
    try { await api.post(`/tournaments/${tid}/broadcasts`, { scope, message: msg }); setMsg(''); load(); } catch {}
    setBusy(false);
  };
  const del = async (bid) => { await api.delete(`/broadcasts/${bid}`); load(); };

  return (
    <div className="space-y-4">
      <div className="bg-[#1C1C1E] border border-gray-800 rounded-2xl p-4 space-y-3">
        <div className="flex items-center gap-2 text-[#00BFFF]"><Megaphone size={16} /><span className="text-[10px] uppercase font-bold tracking-widest text-gray-500">New Broadcast</span></div>
        <div className="flex gap-2">
          {['all', 'group', 'venue'].map((s) => (
            <button key={s} data-testid={`scope-${s}`} onClick={() => setScope(s)} className={`flex-1 py-2 rounded-lg text-[11px] font-bold uppercase ${scope === s ? 'bg-[#00BFFF] text-black' : 'bg-[#0A0A0A] text-gray-400 border border-gray-800'}`}>{s}</button>
          ))}
        </div>
        <textarea data-testid="broadcast-text" className="w-full h-20 bg-[#0A0A0A] border border-gray-800 rounded-xl p-3 text-sm text-white focus:outline-none focus:border-[#00BFFF]" placeholder="e.g. Pitch 2 closed — Final moved to Pitch 1" value={msg} onChange={(e) => setMsg(e.target.value)} />
        <button data-testid="broadcast-send" onClick={send} disabled={busy} className="w-full bg-[#00BFFF] text-black font-bold py-3 rounded-xl flex items-center justify-center gap-2 disabled:opacity-50">
          <Send size={16} /> {busy ? 'Sending…' : 'BROADCAST'}
        </button>
      </div>

      <div className="space-y-2">
        {list.length === 0 ? <p className="text-center text-gray-600 py-8 text-sm">No broadcasts sent yet.</p> :
          list.map((b) => (
            <div key={b.id} data-testid={`broadcast-${b.id}`} className="bg-[#1C1C1E] border border-gray-800 rounded-xl px-4 py-3">
              <div className="flex justify-between items-start">
                <span className="text-[9px] uppercase tracking-widest bg-[#00BFFF]/15 text-[#00BFFF] px-2 py-0.5 rounded-full">{b.scope}</span>
                <button onClick={() => del(b.id)} data-testid={`broadcast-delete-${b.id}`} className="text-gray-600 hover:text-[#FF3B30]"><Trash2 size={14} /></button>
              </div>
              <p className="text-sm mt-2">{b.message}</p>
              <p className="text-[10px] text-gray-600 mt-1">{b.author} • {new Date(b.created_at).toLocaleString()}</p>
            </div>
          ))}
      </div>
    </div>
  );
}
